//Quick View

$(document).ready(function () {
    $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
      quickViewTwo();
    });
  });
  
  function quickViewTwo() {
    $(".quick-view-two").click(function () {
      if ($('#quick-view-two').length == 0){
        $("body").append('<div id="quick-view-two">{% render "quickview2" %}</div>');
      }
      var product_handle = $(this).data('handle');
      $('#quick-view-two').addClass(product_handle);
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        console.log('product===>'+ product);
        var title = product.title;
        var type = product.type;
        var price = 0;
        var original_price = 0;
        var images = product.images;
        var variants = product.variants;
        var options = product.options;
        var url = '/products/' + product_handle;
        var mini_description = product.metafields?.custom?.mini_description || '';
      
        
        $('.qv-two-product-title-link').text(title).attr('href', url);
        $('.qv-two-product-title').find('.qv-two-product-title-link').text(title).attr('href', url);
        $('.qv-two-product-type').text(type);
        $('.qv-two-product-mini-description').html(mini_description);
        $('.view-product').attr('href', url);
        var imageCount = $(images).length;
        $(images).each(function (i, image) {
          if (i == imageCount - 1) {
            var image_embed = '<div><img src="' + image + '"></div>';
            image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
            $('.qv-two-product-images').append(image_embed);
  
            $('.qv-two-product-images').slick({
              'dots': true,
              'arrows': true,
              'respondTo': 'min',
              'useTransform': false
            }).css('opacity', '1');
  
          } else {
            image_embed = '<div><img src="' + image + '"></div>';
            image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
            $('.qv-two-product-images').append(image_embed);
          }
        });
  $(options).each(function (i, option) {
    var opt = option.name;
    console.log('opt==>' + opt);
  
    // Sanitize opt by replacing spaces and special characters with hyphens or empty string
    var sanitizedOpt = opt.toLowerCase().replace(/[^a-z0-9]/gi, '-');
  
    // Create the select class using the sanitized value
    var selectClass = '.option.' + sanitizedOpt;
  
    // Append the option selector to the product options container
    $('.qv-two-product-options').append('<div class="option-selection-' + sanitizedOpt + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + sanitizedOpt + '"></select></div>');
  
    // Append the values to the select element
    $(option.values).each(function (i, value) {
      $('.option.' + sanitizedOpt).append('<option value="' + value + '">' + value + '</option>');
    });
  });
  
        $(product.variants).each(function (i, v) {
          if (v.inventory_quantity == 0) {
            $('.qv-two-add-button').prop('disabled', true).val('Sold Out');
            $('.qv-two-add-to-cart').hide();
            $('.qv-two-product-price').text('Sold Out').show();
            return true
          } else {
            price = parseFloat(v.price / 100).toFixed(2);
            original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            $('.qv-two-product-price').text('€' + price);
            if (original_price > 0) {
              $('.qv-two-product-original-price').text('€' + original_price).show();
            } else {
              $('.qv-two-product-original-price').hide();
            }
            $('select.option-0').val(v.option1);
            $('select.option-1').val(v.option2);
            $('select.option-2').val(v.option3);
            return false
          }
        });
      });
  
      $(document).on("change", "#quick-view-two select", function () {
        var selectedOptions = '';
        $('#quick-view-two select').each(function (i) {
          if (selectedOptions == '') {
            selectedOptions = $(this).val();
          } else {
            selectedOptions = selectedOptions + ' / ' + $(this).val();
          }
        });
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          $(product.variants).each(function (i, v) {
            if (v.title == selectedOptions) {
              var price = parseFloat(v.price / 100).toFixed(2);
              var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
              var v_qty = v.inventory_quantity;
              var v_inv = v.inventory_management;
              $('.qv-two-product-price').text('€' + price);
              $('.qv-two-product-original-price').text('€' + original_price);
              if (v_inv == null) {
                $('.qv-two-add-button').prop('disabled', false).val('Toevoegen aan winkelwagen');
              } else {
                if (v.inventory_quantity < 1) {
                  $('.qv-two-add-button').prop('disabled', true).val('Sold Out');
                } else {
                  $('.qv-two-add-button').prop('disabled', false).val('Toevoegen aan winkelwagen');
                }
              }
            }
          });
        });
      });
      $.fancybox({
        href: '#quick-view-two',
        maxWidth: 1040,
        maxHeight: 500,
        fitToView: true,
        width: '95%',
        height: '70%',
        autoSize: false,
        closeClick: false,
        openEffect: 'none',
        closeEffect: 'none',
        'beforeLoad': function () {
          var product_handle = $('#quick-view-two').attr('class');
          $(document).on("click", ".qv-two-add-button", function () {
            var qty = $('.qv-quantity').val();
            var selectedOptions = '';
            var var_id = '';
            $('#quick-view-two select').each(function (i) {
              if (selectedOptions == '') {
                selectedOptions = $(this).val();
              } else {
                selectedOptions = selectedOptions + ' / ' + $(this).val();
              }
            });
            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
              $(product.variants).each(function (i, v) {
                if (v.title == selectedOptions) {
                  var_id = v.id;
                  processCart();
                }
              });
            });
            function updateCartDrawer() {
              fetch(window.location.href)
                .then((response) => response.text())
                .then((html) => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, "text/html");
                  const newCartDrawer = doc.querySelector(".drawer__inner");
                  const currentCartDrawer = document.querySelector(".drawer__inner");
                  if (currentCartDrawer && newCartDrawer) {
                    currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
                  }
                })
                .catch((error) => {
                  console.error("Error fetching the cart drawer:", error);
                });
            }
            function processCart() {
              jQuery.post('/cart/add.js', {
                quantity: qty,
                id: var_id
              },
                          null,
                          "json"
                         ).done(function () {
                
                //$('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
                setTimeout(function() {
                updateCartDrawer();
                $('.drawer').addClass('active');
                $('.fancybox-close').trigger('click');
                }, 1000);
              })
              .fail(function ($xhr) {
                var data = $xhr.responseJSON;
                $('.qv-two-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
              });
            }
          });
          $('.fancybox-wrap').css('overflow', 'hidden !important');
        },
        'afterShow': function () {
          $('#quick-view-two').hide().html(quickview2Content).css('opacity', '1').fadeIn(function () {
            $('.qv-two-product-images').addClass('loaded');
          });
        },
        'afterClose': function () {
          $('#quick-view-two').removeClass().empty();
        }
      });
    });
  };
  
  $(window).resize(function () {
    if ($('#quick-view-two').is(':visible')) {
      $('.qv-two-product-images').slick('setPosition');
    }
  });
  
  